<script>
    import {eventBus} from "../core/event-bus-store.js";
    import {get} from "svelte/store";
    import {mediaUrlStore} from "../core/app-store.js";

    export let tenantKey = '';

    const mediaUrl = get(mediaUrlStore);

    let lightboxImageSrc = null;
    let lightboxImageTitle = null;
    let lightboxImageText = null;


    eventBus.subscribe(e => {

        if (e && e.length > 0) {

            e.forEach(x => {
                if (x?.event === 'openFullscreen' && x?.payload?.media?.type === 'photo') {

                    lightboxImageSrc = `${mediaUrl}${x.payload.media.ref || tenantKey}${x.payload.media.url}`;
                    lightboxImageTitle = x?.payload?.media.title;
                    lightboxImageText = x?.payload?.media.text;
                }
            });
        }
    });

    function close() {

        lightboxImageSrc = null;
        lightboxImageTitle = null;
        lightboxImageText = null;
    }

</script>
<style>

.lightbox-container {
    position: fixed;
    z-index: 10000;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;

    pointer-events: none;
    opacity: 0;

    transition: opacity .3s ease;
}
.lightbox-container--open {
    background: var(--backdrop-color);
    pointer-events: all;
    opacity: 1;
}
.lightbox {
    position: relative;
    display: flex;
    background: var(--bg-color);
    padding: 2px;
    box-shadow: 0 .25rem 1rem 0 rgba(0,0,0,0.25);
    cursor: pointer;
    overflow: hidden;
    border-radius: var(--border-radius-xs);
    pointer-events: all;

    max-height: 100%;
    max-width: 100%;

    transform: translate(0, 15%) scale(.95);
    transition: transform .3s ease;
}
.lightbox-container--open .lightbox {
    transform: translate(0, 0) scale(1);
}
.lightbox img {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
    border-radius: 6px;
}
.title-container {
    position: absolute;
    z-index: 10;
    bottom: 0;
    left: 0;
    padding: .75rem 1rem;
    width: 100%;
    background: #00000055;
    color: white;
}
.title-container .title {
    font-weight: 600;
}
.title-container .text {}

</style>

<div class="lightbox-container"
     class:lightbox-container--open={ lightboxImageSrc != null }
     on:click={() => close()} >

    <div class="lightbox">

        {#if (lightboxImageTitle || lightboxImageText) }
            <div class="title-container">
                {#if (lightboxImageTitle) }
                    <div class="title">{ lightboxImageTitle }</div>
                {/if}

                {#if (lightboxImageText) }
                    <div class="text">{ lightboxImageText }</div>
                {/if}
            </div>
        {/if}


        <img src={ lightboxImageSrc } loading="lazy">
    </div>

</div>
